import { WebRecadParticipanteDadosEntidade, DependenteEntidade } from ".";

export class WebRecadDadosConclusaoEntidade {
  Participante: WebRecadParticipanteDadosEntidade;
  ListaDependentes: Array<DependenteEntidade>;
  ListaDependentesIR: Array<DependenteEntidade>;
  ListaArquivo: Array<string>;
  CPF_Original: string;
  OID_RECAD_PUBLICO_ALVO_Original: number;
  Origem: number;
  TOKEN_ENVIADO: string;
  TOKEN_DIGITADO: string;
}